import apiClient from '@/services/axios'

export async function post(templateId, venueId, year) {
  var response = await apiClient.post(`/ActivationPlanCampaigns/template/${templateId}/${year}/${venueId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to import campaigns from template')
}